var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pole-container"},[(_vm.poleSelectedNode.isLeaf)?_c('ManholeBaseIndex',{staticClass:"content-item"}):_c('ManholeGroupIndex')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }